import { shallowEqual, useDispatch, useSelector } from "react-redux";
import Cookies from "../types/cookies.type";
import { parseCookies } from "nookies";
import useUserRole from "./useUserRole.hook";
import { useCallback, useEffect } from "react";
import {
  GET_VENDOR_IMPERSONATION_STATE,
  SET_IS_IMPERSONATION_SESSION_EXPIRED,
  SET_VENDOR_IMPERSONATION,
} from "../redux/slices/impersonationSlice";
import useBrowserWindowActivity from "./useBrowserWindowActivity.hook";
import { refreshPage } from "../utilities/url.functions";
import { StoreType } from "../redux/StoreType";

const useVendorImpersonation = (userRole: string | string[]) => {
  const dispatch = useDispatch();
  const cookies: Cookies = parseCookies();

  const { isVendorAdmin } = useUserRole(userRole);
  const { isInitialWindowLoad, isBrowserWindowActive } =
    useBrowserWindowActivity();

  const {
    impersonation: { isVendorImpersonationSet, impersonatedUserEmail },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  useEffect(() => {
    if (
      isVendorAdmin &&
      cookies.ImpersonatingUser &&
      !isVendorImpersonationSet
    ) {
      dispatch(SET_VENDOR_IMPERSONATION(cookies.ImpersonatingUser));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshPageOnUserChange = useCallback(() => {
    if (isVendorImpersonationSet) {
      refreshPage();
    }
  }, [isVendorImpersonationSet]);

  useEffect(() => {
    if (
      isVendorAdmin &&
      !isInitialWindowLoad &&
      isBrowserWindowActive &&
      cookies.ImpersonatingUser !== impersonatedUserEmail
    ) {
      if (cookies.ImpersonatingUser) {
        refreshPageOnUserChange();
        dispatch(SET_VENDOR_IMPERSONATION(cookies.ImpersonatingUser));
      } else {
        dispatch(SET_IS_IMPERSONATION_SESSION_EXPIRED());
      }
    }
  }, [
    isVendorAdmin,
    isInitialWindowLoad,
    isBrowserWindowActive,
    cookies.ImpersonatingUser,
    impersonatedUserEmail,
    dispatch,
    refreshPageOnUserChange,
  ]);
};

export default useVendorImpersonation;
